/**
 * Permission coordinates for Fetcher Settings, in the shape
 * CheckPermissions(userData.data.products.data_collection, capability, key)
 * expects. Kept in one place because the view gate sits on the Screen and the
 * create/edit gate sits inside each tab.
 */
export const FETCHER_CAPABILITY = "fetcher_settings";
export const FETCHER_VIEW_PERMISSION = "view_fetcher_settings";
